(ns app.zap-vault.main
  (:require
   [app.zap-vault.event :as zap-vault-events]
   [app.zap-vault.routes :as routes]
   [app.zap-vault.view :as view]
   [common.dates :as dates]
   [comms.sente :as sente]
   [fx.timer :as timer-fx]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [reagent.dom :as rd]
   [ui.dom-globals :as dg]
   [ui.tailwind-theme :as tailwind-theme]
   [ui.window :as window]))

(defn resolve-theme!
  []
  (let [elem (dg/element-by-id "zap-vault-theme")

        classes (dg/get-attribute elem "classList")
        _ (println "CLASSES" classes)
        tailwind-theme (oops/oget elem "dataset.theme")
        _ (println "TW theme" tailwind-theme)]
    (tailwind-theme/set-theme! tailwind-theme)))

(defn init!
  []
  (resolve-theme!)
  (routes/start!)
  (dates/initialize-timezone! "Etc/UTC")
  (sente/init!)
  (rf/dispatch [::routes/navigate [:loading]])
  (rf/dispatch [::zap-vault-events/load-app-config true])
  (rf/dispatch [::window/track-window-size])
  (rf/dispatch [::timer-fx/start-clock])


  (rd/render [view/view]
             (dg/element-by-id "zap-vault-application")))

;; hook for shadow-cljs watch (hot code reload)
(defn ^:dev/after-load refresh
  []
  ;;force re-render so changes are immediately visible:
  (rd/render [view/view]
             (dg/element-by-id "zap-vault-application")))
